import { gql } from "@apollo/client";

export const GET_CREATED_CLIENT_INFO = gql`
  query listClientsInfo($filter: ClientInfoFilter, $offset: Int, $limit: Int, $orderBy: [String!]) {
    listClientsInfo(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        vatNumber
        code
        paymentMethod {
          id
          name
        }
        clientConfig {
          clientVatType {
            id
            code
            name
          }
          paymentDeadline {
            id
            name
            payDay
            numberOfDays
            editable
            description
            canBeDeleted
            canBeArchived
            beginningDay
            archivedBy
            archivedAt
          }
          currency {
            id
            code
          }
        }
      }
    }
  }
`;

export const GET_CLIENT_CONFIG_CREATE_INVOICE = gql`
  query getClientConfig($id: ID!) {
    getClientConfig(clientId: $id) {
      clientId
      paymentMethod {
        id
        name
      }
      paymentDeadline {
        id
        name
        payDay
        numberOfDays
        editable
        description
        canBeDeleted
        canBeArchived
        beginningDay
        archivedBy
        archivedAt
      }
      currencySetting {
        id
        code
      }
      clientVatType {
        id
        code
        name
      }
    }
  }
`;

export const LIST_SEPA_ORDERS = gql`
  query listSepaOrders(
    $filter: ListSEPAOrderFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listSepaOrders(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        endDate
        startDate
        reference
        paymentPeriod {
          label
          value
        }
        companyId
        clientId
      }
    }
  }
`;

export const LIST_SEPA_ORDERS_COUNT = gql`
  query listSepaOrders(
    $filter: ListSEPAOrderFilter!
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listSepaOrders(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
      }
    }
  }
`;

export const LIST_CLIENT_BANK_ACCOUNTS = gql`
  query listClientBankAccountsPaginated(
    $filter: ClientBankAccountFilter
    $limit: Int
    $offset: Int
    $orderBy: [String]
  ) {
    listClientBankAccountsPaginated(filter: $filter) {
      totalCount
      results(limit: $limit, offset: $offset, orderBy: $orderBy) {
        id
        isMain
        isActive
      }
    }
  }
`;

export const LIST_PAYMENT_PERIODS = gql`
  query listPaymentPeriods {
    listPaymentPeriods {
      label
      value
    }
  }
`;

export const LIST_CLIENTS_WITH_SEARCH_VAR = gql`
  query listClientsInfo(
    $search: String
    $company: ID
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listClientsInfo(filter: { search: $search, companyId: $company }) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        vatNumber
        code
        paymentMethod {
          id
          name
        }
        clientConfig {
          clientVatType {
            id
            code
            name
          }
          paymentDeadline {
            id
            name
            payDay
            numberOfDays
            editable
            description
            canBeDeleted
            canBeArchived
            beginningDay
            archivedBy
            archivedAt
          }
          currency {
            id
          }
        }
      }
    }
  }
`;

export const GET_CLIENT_CONFIG = gql`
  query getClientConfig($id: ID!) {
    getClientConfig(clientId: $id) {
      note
      clientVatType {
        id
        name
        code
      }
      counterpartCode
      counterpartData {
        id
        name
        code
      }
      paymentMethod {
        id
        name
      }
      paymentDeadline {
        id
        name
      }
      currencySetting {
        id
        code
      }
    }
  }
`;

export const GET_SEPA_ORDERS = gql`
  query getSepaOrder($id: ID!) {
    getSepaOrder(id: $id) {
      id
      endDate
      startDate
      paymentPeriod {
        label
        value
      }
      reference
      companyId
      clientId
      bankId
      autorizationFile
    }
  }
`;

export const UPDATE_CLIENT_INFO = gql`
  mutation updateClientInfo($input: ClientInfoUpdateInput!) {
    updateClientInfo(input: $input) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_CLIENT_INFO = gql`
  mutation createClientInfo($input: ClientInfoCreateInput!) {
    createClientInfo(input: $input) {
      clientInfo {
        id
      }
      errors {
        field
        messages
      }
    }
  }
`;

export const CREATE_SEPA_ORDER = gql`
  mutation createSepaOrder($input: SEPAOrderCreateInput!) {
    createSepaOrder(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const UPDATE_SEPA_ORDER = gql`
  mutation updateSepaOrder($input: SEPAOrderUpdateInput!) {
    updateSepaOrder(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;

export const LIST_CLIENT_ACCOUNTS = gql`
  query listClientInfoAccount($filter: ClientInfoAccountsFilterInput) {
    listClientInfoAccount(filter: $filter) {
      id
      client {
        code
        name
        id
        cycle {
          id
          startDate
          endDate
        }
      }
      clientInfo {
        id
        code
        name
      }
    }
  }
`;

export const DELETE_CLIENT_INFO = gql`
  mutation deleteClientInfo($id: ID!) {
    deleteClientInfo(id: $id) {
      success
      errors {
        field
        messages
      }
    }
  }
`;

export const LIST_CLIENT_ACCOUNTS_FOR_ASYNC_SELECT = gql`
  query listClientsPaginated(
    $filter: ClientFilterInput
    $offset: Int
    $limit: Int
    $orderBy: [String]
  ) {
    listClientsPaginated(filter: $filter) {
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        code
        name
        cycle {
          startDate
          endDate
        }
      }
    }
  }
`;

export const LIST_CLIENT_VAT_TYPES_FOR_ASYNC_SELECT = gql`
  query listClientVatTypes(
    $filter: ClientVatTypeFilter
    $offset: Int
    $limit: Int
    $orderBy: [String!]
  ) {
    listClientVatTypes(filter: $filter) {
      totalCount
      results(offset: $offset, limit: $limit, orderBy: $orderBy) {
        id
        name
        code
      }
    }
  }
`;

export const GET_CLIENT = gql`
  query getClient($id: ID!) {
    getClient(id: $id) {
      id
      name
      shortName
      vatNumber
      code
      isCollective
      isPeriodic
      hasQuantityTracking
      hasQuantityTracking2
      hasCurrencyTracking
      currency {
        label
        value
      }
      reconciliation
      defaultCounterParts {
        id
        name
        code
      }
      counterPart {
        id
        name
        code
      }
      company {
        id
      }
      vat {
        id
        rate
        code
      }
      cycle {
        id
        startDate
        endDate
      }
      isActive
      chorus
      type {
        label
        value
      }
    }
  }
`;
